import { useIsMobile } from "hooks/useIsMobile";
import { EventSearchMobile } from "../../../layout/event/search/EventSearchMobile";
import { EventSearchDesktop } from "../../../layout/event/search/EventSearchDesktop";

export const EventSearch = ({ event }) => {
    const isMobile = useIsMobile();
    const shouldDisplay =
        ["scheduled", "drawn", "upcoming", "cancelled"].indexOf(
            event.status,
        ) === -1;

    return (
        shouldDisplay &&
        (isMobile ? (
            <EventSearchMobile event={event} />
        ) : (
            <EventSearchDesktop event={event} />
        ))
    );
};
